import React, { useContext, useState } from 'react';
import BaseViewsContext from '../../../contexts/BaseViewsContext';
import CanvasCard from '../../Visualisations/CanvasCard';
import DashboardGadgetBottomBar from '../../DashboardGadgetBottomBar';
import { TopBar } from '../Matrix';
import SimpleGridContent from './SimpleGridContent';
import type { GridApi } from 'ag-grid-community';
import DashboardGadgetContext from '../../../contexts/DashboardGadgetContext';
import {
  usePublishBlockExportHandle,
  usePublishBlockGridApi,
} from '../../Studio/BlockGridApiContext';

const WrappedTopBar = ({
  chartDefinition,
  gridApi,
  exportHandle,
}: {
  chartDefinition: V5ChartDefinition;
  gridApi?: GridApi;
  exportHandle?: DataTable.ExportHandle;
}) => {
  if (gridApi || exportHandle) {
    return (
      <TopBar
        exportName={chartDefinition.name}
        gridApi={gridApi}
        exportHandle={exportHandle}
        title={chartDefinition.name}
      />
    );
  } else {
    return null;
  }
};

const SimpleGridContainer = ({
  chartDefinition,
  simpleGridConfig,
  parentBaseView,
}: {
  chartDefinition: V5ChartDefinition;
  simpleGridConfig: SimpleGridConfig;
  parentBaseView: FleetOps.BaseView;
}) => {
  const [gridApi, setGridApi] = useState<GridApi>();
  const [exportHandle, setExportHandle] = useState<DataTable.ExportHandle>();
  const { dashboardGadget } = useContext(DashboardGadgetContext);
  // A Studio records Table exports it from its own menu
  usePublishBlockGridApi(gridApi);
  usePublishBlockExportHandle(exportHandle);

  return (
    <CanvasCard
      topBar={
        <WrappedTopBar
          chartDefinition={chartDefinition}
          gridApi={gridApi}
          exportHandle={exportHandle}
        />
      }
      content={
        <SimpleGridContent
          simpleGridConfig={simpleGridConfig}
          parentBaseView={parentBaseView}
          chartDefinition={chartDefinition}
          gridApi={gridApi}
          setGridApi={setGridApi}
          setExportHandle={setExportHandle}
        />
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
      isContentWithoutPadding
    />
  );
};

const Gate = ({ chartDefinition }: { chartDefinition: V5ChartDefinition }) => {
  const { simpleGridConfig } = chartDefinition;
  const { baseViews } = useContext(BaseViewsContext);

  if (!simpleGridConfig) {
    return null;
  }

  const parentBaseView = baseViews[simpleGridConfig.dataType];
  if (!parentBaseView || simpleGridConfig.fields.length === 0) {
    return null;
  }
  return (
    <SimpleGridContainer
      chartDefinition={chartDefinition}
      simpleGridConfig={simpleGridConfig}
      parentBaseView={parentBaseView}
    />
  );
};

export default Gate;
